module.exports = __webpack_public_path__ + "img/Group231.ecf92154.png";